// frontend/src/pages/CustomerFavorites.tsx
import React from 'react';

const CustomerFavorites: React.FC = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">My Favorites</h1>
      <p>Your saved providers and services.</p>
    </div>
  );
};

export default CustomerFavorites;